import axios from "axios";
import configData from "config.json";
import { authHeader } from "helpers/auth-header";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { ResponseRequestGeneric } from "Types/GeneralTypes";
import { URL_CONTROLLER_ASIGNACION_PRESUPUESTO } from "../Asignacion Presupuesto/FunctionsAsignacionPresupuesto";
import { HistorialModificacionPHE, HistorialUnidadesModPHE } from "../Asignacion Presupuesto/TypesPresupuestoGPEHE";


const URL_HISTORIAL_MODIFICACIONES_PRESUPUESTO_UNIDAD = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/InformacionHistorialUnidades`
const URL_HISTORIAL_MODIFICACIONES_PRESUPUESTO = `${configData.SERVER_URL}ModificacionPresupuestoHE/HistorialModificacionesPHE`
const URL_HISTORIAL_UNIDADES_MOD_PHE = `${URL_CONTROLLER_ASIGNACION_PRESUPUESTO}/UnidadesModPresupuestoHE`

export async function ObtenerInformacionHistorialModPHE(anio: number) {
    
    var respuesta: ResponseRequestGeneric<HistorialModificacionPHE[]> = {
        status: -1
    };
    const url = `${URL_HISTORIAL_MODIFICACIONES_PRESUPUESTO_UNIDAD}/${anio}`

    try {
        const responseAxios = await axios.get(url,
            {
                headers: authHeader()
            }
        )
        var data: HistorialModificacionPHE[] = responseAxios.data;
        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<HistorialModificacionPHE[]>(error)
    }
    return respuesta
}

export async function ObtenerHistorialDirectivoModPHE(anio: number) {
    
    var respuesta: ResponseRequestGeneric<HistorialModificacionPHE[]> = {
        status: -1
    };
    const url = `${URL_HISTORIAL_MODIFICACIONES_PRESUPUESTO}/${anio}`

    try {
        const responseAxios = await axios.get(url,
            {
                headers: authHeader()
            }
        )
        var data: HistorialModificacionPHE[] = responseAxios.data;
        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<HistorialModificacionPHE[]>(error)
    }
    return respuesta
}

export async function ObtenerUnidadesHistorialModPHE(anio: number){
    
    var respuesta: ResponseRequestGeneric<HistorialUnidadesModPHE[]> = {
        status: -1
    };
    const url = `${URL_HISTORIAL_UNIDADES_MOD_PHE}/${anio}`
    try {
        const responseAxios = await axios.get(url,
            {
                headers: authHeader()
            }
        )
        var data: HistorialUnidadesModPHE[] = responseAxios.data;
        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }
    } catch (error) {
        respuesta = hadleAxiosErrorResponse<HistorialUnidadesModPHE[]>(error)
    }
    return respuesta
}